import { useState, useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';

import MyCEFDisableUserModal from './disable_user_modal';

const MyCEFDisableUser = ({ url, disableUserUrl, confirmText }) => {
  const [options, setOptions] = useState({});
  const [status, setStatus] = useState('');
  const requestConfig = {
    method: 'GET',
    url: url || null,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  const { error } = useHTTP(requestConfig);

  useEffect(() => {
    if (error) {
      const { error: httpError } = error;
      const {
        title,
        message: description,
        approval_groups: approvalGroups,
      } = httpError.data;

      setStatus('CANNOT_DISABLE');
      setOptions({
        showModal: false,
        title,
        description,
        approvalGroups,
        cta: 'Cancel',
      });
    }
  }, [error]);

  const closeUsersModal = () => {
    setOptions(curOptions => ({ ...curOptions, showModal: false }));
  };

  switch (status) {
    case 'CANNOT_DISABLE':
      return (
        <>
          <button
            type="button"
            className="cef-btn--as-link fs-aside"
            onClick={() =>
              setOptions(curOptions => ({ ...curOptions, showModal: true }))
            }>
            Disable this User
          </button>
          {/* Modal Used to Disable Selected User */}
          <MyCEFDisableUserModal
            options={options}
            closeModal={closeUsersModal}
          />
        </>
      );

    default:
      return (
        <a
          data-confirm={confirmText}
          rel="nofollow"
          data-method="put"
          href={disableUserUrl}>
          Disable this User
        </a>
      );
  }
};

export default MyCEFDisableUser;
